<div
  #tabsContainer
  class="header header-desktop"
  [ngClass]="{
    'pr-medium-x': layoutType() === TabLayoutType.IN_MODAL,
    'mr-small-b':
      theme() === TabTheme.DEFAULT &&
      (layoutType() === TabLayoutType.DEFAULT || layoutType() === TabLayoutType.IN_MODAL),
    'border-bottom': bottomBorder() && theme() === TabTheme.DEFAULT && layoutType() !== TabLayoutType.HAS_BACKGROUND,
    'before-border relative': theme() === TabTheme.CLASSIC && layoutType() !== TabLayoutType.HAS_BACKGROUND,
  }"
>
  <div class="flex flex--center mobile-reverse">
    <fcom-carousel
      #carousel
      class="flex-1 overflow-auto"
      [align]="align()"
      [hasGreyBackground]="hasGreyBackground()"
      [hasContainerShadow]="carouselHasContainerShadow()"
      [iconButtonSize]="carouselButtonSize()"
      [nextButtonAriaLabel]="nextButtonAriaLabel()"
      [prevButtonAriaLabel]="prevButtonAriaLabel()"
      [theme]="layoutType() === TabLayoutType.HAS_BACKGROUND ? CarouselTheme.HAS_BACKGROUND : CarouselTheme.DEFAULT"
    >
      <ul #tabsNavi class="unstyled flex flex--no-wrap" role="tablist">
        @for (tab of tabs(); track tab.tabId) {
          <li
            role="none"
            class="tab-item"
            [class.tab--default]="theme() === TabTheme.DEFAULT"
            [class.tab--classic]="theme() === TabTheme.CLASSIC"
            [class.tab--stretch]="layoutType() === TabLayoutType.STRETCH"
            [class.tab--modal]="layoutType() === TabLayoutType.IN_MODAL"
            [class.tab--background]="layoutType() === TabLayoutType.HAS_BACKGROUND"
            [class.tab--active]="tab.isActive()"
            [class.tab-item--no-subtitle]="!showSubtitle()"
          >
            <button
              [attr.data-testid]="tab.tabTitleDataTestId()"
              class="tab-button {{
                layoutType() === TabLayoutType.STRETCH
                  ? tabStyleOverrideClasses()
                    ? tabStyleOverrideClasses()
                    : 'ps-medium-t ps-xxsmall-x'
                  : ''
              }}"
              [ngClass]="{
                'flex flex--middle':
                  theme() === TabTheme.DEFAULT && tab.icon() && tab.icon().position === TabIconPosition.LEFT,
                nowrap: whiteSpaceNowrap() === true,
              }"
              [disabled]="tab.disabled()"
              (click)="selectTab(tab)"
              [attr.aria-selected]="tab.isActive()"
              [attr.aria-controls]="tab.tabId"
              role="tab"
              [id]="tab.tabId + '-tab'"
            >
              @if (theme() === TabTheme.DEFAULT && tab.icon().name) {
                <fcom-icon
                  class="icon-medium"
                  [class.ms-xxsmall-r]="tab.icon() && tab.icon().position === TabIconPosition.LEFT"
                  [name]="tab.icon().name"
                />
              }
              @if (tab.title()) {
                <span
                  class="tab-title"
                  [ngClass]="{
                    'flex medium-type': theme() !== TabTheme.CLASSIC,
                    'block font-body-medium-bold': theme() === TabTheme.CLASSIC,
                  }"
                >
                  {{ tab.title() }}
                  @if (tab.contentPopover()) {
                    <ng-container
                      [ngTemplateOutlet]="popover"
                      [ngTemplateOutletContext]="{
                        contentPopover: tab.contentPopover(),
                      }"
                    />
                  }
                </span>
              }
              @if (tab.subtitle()) {
                <span
                  class="tab-subtitle block"
                  [ngClass]="{
                    'light-type': theme() !== TabTheme.CLASSIC,
                    'font-body-medium ms-xsmall-b': theme() === TabTheme.CLASSIC,
                  }"
                >
                  {{ tab.subtitle() }}
                </span>
              }
            </button>
          </li>
        }

        <ng-template #popover let-contentPopover="contentPopover">
          <fcom-icon-button
            data-testid="tabs-popover"
            class="ms-xxsmall-l"
            [size]="IconButtonSize.SMALL"
            [theme]="IconButtonTheme.SECONDARY_OUTLINE"
            [icon]="{ name: SvgLibraryIcon.HELP }"
            [aria]="{
              label: 'actions.info' | finLocalization,
            }"
            fcomPopover
            [options]="{
              enableStopPropagation: true,
            }"
            [content]="contentPopover"
          />
        </ng-template>
      </ul>
    </fcom-carousel>
    <div class="flex--nogrow mobile-right">
      <ng-content select="tabSidebar" />
    </div>
  </div>
</div>
<div
  class="tab-content"
  [class.tab-content--in-modal]="layoutType() === TabLayoutType.IN_MODAL"
  [class.tab-content--stretch]="layoutType() === TabLayoutType.STRETCH"
  [class.tab-content--default]="theme() === TabTheme.DEFAULT && layoutType() === TabLayoutType.DEFAULT"
  [class.tab-content--classic]="theme() === TabTheme.CLASSIC"
  [class.tab-content--has-background]="layoutType() === TabLayoutType.HAS_BACKGROUND"
>
  <ng-content />
</div>
